export default __webpack_public_path__ + "static/media/ic_fare_b.e157a0ea.svg";